import React, { useEffect, useRef, useState, useImperativeHandle, forwardRef } from 'react';
import { HotKeys } from '../../library/HotKeys/react-hotkeys';
import useCreateCallbackForEvent from '../../../hooks/useCreateCallbackForEvent';
import useThrottleForEvent from '../../../hooks/useThrottleForEvent';
import { LIST_MODEL } from '../../constant';
export var ListHotKey;
(function (ListHotKey) {
    ListHotKey["KEY_UP"] = "KEY_UP";
    ListHotKey["KEY_DOWN"] = "KEY_DOWN";
    ListHotKey["SHIFT_KEY_UP"] = "SHIFT_KEY_UP";
    ListHotKey["SHIFT_KEY_DOWN"] = "SHIFT_KEY_DOWN";
    ListHotKey["COMMAND_A"] = "COMMAND_A";
    ListHotKey["COMMAND_R"] = "COMMAND_R";
    ListHotKey["ENTER"] = "ENTER";
})(ListHotKey || (ListHotKey = {}));
export const keyMap = {
    [ListHotKey.KEY_UP]: 'up',
    [ListHotKey.KEY_DOWN]: 'down',
    [ListHotKey.SHIFT_KEY_UP]: 'shift+up',
    [ListHotKey.SHIFT_KEY_DOWN]: 'shift+down',
    [ListHotKey.COMMAND_A]: ['command+a', 'control+a', 'ctrl+a'],
    [ListHotKey.ENTER]: 'enter',
};
const defaultGetUniqKey = (index) => index + '';
const defaultRowHeight = (index) => 20;
const HotKey = (ListCom, CustomEventOrign) => forwardRef((props, ref) => {
    const { data = [], getUniqKey = defaultGetUniqKey, activeId = [], onSelect, onUnSelect, onActive, onActiveInWindow, onListModelChange, onDelete, onContextMenu, selectModel = LIST_MODEL.INIT, hkDisabled = false, beforeSelected, } = props;
    useEffect(() => {
        refListModel.current = selectModel;
    }, [selectModel]);
    const refListModel = useRef(selectModel);
    const [shiftActiveId, setShiftActiveId] = useState(null);
    const [shiftCurId, setShiftCurId] = useState(null);
    const _activeIds = useRef([]);
    const [mailId2ListIndexMap, setId2IndexMap] = useState(new Map());
    const activeIdsMap = useRef(new Map());
    const [preMailSumHeightMap, setPreMailSumHeight] = useState(new Map());
    const [dataItem2keyMap, setDateItem2keyMap] = useState(new Map());
    const listRef = useRef();
    const modelLockRef = useRef(false);
    const findFirstIdGroup = () => {
        return [];
    };
    useEffect(() => {
        if (activeId != null && Array.isArray(activeId)) {
            if (!(activeId.length === _activeIds.current.length && activeId.every(id => idIsActive(id)))) {
                if (activeId.length == 0) {
                    reset();
                }
                else {
                    _activeIds.current = activeId;
                    if (activeId.length == 1) {
                        setShiftActiveId(activeId[0]);
                        setShiftCurId(activeId[0]);
                        if (selectModel && selectModel === LIST_MODEL.MULTIPLE && !modelLockRef.current) {
                            setListModel(LIST_MODEL.SINGLE);
                        }
                    }
                    else {
                        if (selectModel && selectModel != LIST_MODEL.MULTIPLE) {
                            setListModel(LIST_MODEL.MULTIPLE);
                        }
                        const group = findFirstIdGroup();
                        if (group && group.length) {
                            const start = group[0];
                            const end = group[group.length - 1];
                            setShiftActiveId(start);
                            setShiftCurId(end);
                        }
                    }
                }
                _activeIds.current = activeId;
                activeIdsMap.current.clear();
                setActiveIdsMap(map => {
                    activeId.forEach(id => {
                        map.set(id, true);
                    });
                    return map;
                });
            }
        }
    }, [activeId]);
    const setListModel = model => {
        refListModel.current = model;
        onListModelChange && onListModelChange(model, _activeIds === null || _activeIds === void 0 ? void 0 : _activeIds.current);
    };
    const id2Index = id => mailId2ListIndexMap.get(id);
    const idIsActive = id => {
        if (_activeIds.current && _activeIds.current.length) {
            return _activeIds.current.includes(id);
        }
        return false;
    };
    const setActiveIds = ids => {
        if (Array.isArray(ids)) {
            _activeIds.current = ids;
        }
        else if (ids) {
            _activeIds.current = ids(_activeIds.current);
        }
    };
    const setActiveIdsMap = map => {
        if (map instanceof Map) {
            activeIdsMap.current = map;
        }
        else if (map) {
            activeIdsMap.current = map(activeIdsMap.current);
        }
    };
    const reset = () => {
        setListModel(LIST_MODEL.INIT);
        setActiveIds([]);
        setActiveIdsMap(new Map());
        if (data && data.length) {
            const id = dataItem2keyMap.get(data[0]);
            setShiftActiveId(id);
            setShiftCurId(id);
        }
        else {
            setShiftActiveId(null);
            setShiftCurId(null);
        }
    };
    const clearActive = () => {
        setActiveIds([]);
        setActiveIdsMap(new Map());
    };
    const deleteActiveId = id => {
        if (typeof id === 'string') {
            if (idIsActive(id)) {
                setActiveIds(ids => ids.filter(mailId => mailId != id));
                setActiveIdsMap(map => {
                    map.delete(id);
                    return map;
                });
            }
        }
        else if (Array.isArray(id)) {
            const ids = id.filter(mailId => idIsActive(mailId));
            if (ids && ids.length) {
                setActiveIds(_activeIds => _activeIds.filter(mailId => !ids.includes(mailId)));
                setActiveIdsMap(map => {
                    ids.forEach(mailId => {
                        map.delete(mailId);
                    });
                    return map;
                });
            }
        }
    };
    const addSingleActiveId = id => {
        if (typeof id === 'string') {
            if (idIsActive(id))
                return null;
            setActiveIds([id]);
            setActiveIdsMap(map => {
                map.set(id, true);
                return map;
            });
        }
    };
    const addActiveId = id => {
        if (typeof id === 'string') {
            if (idIsActive(id))
                return null;
            setActiveIds(ids => [...ids, id]);
            setActiveIdsMap(map => {
                map.set(id, true);
                return map;
            });
        }
        else if (Array.isArray(id)) {
            const ids = id.filter(id => !idIsActive(id));
            if (!ids.length)
                return null;
            setActiveIds(_ids => [..._ids, ...ids]);
            setActiveIdsMap(map => {
                ids.forEach(id => {
                    map.set(id, true);
                });
                return map;
            });
        }
    };
    const listScrollToTop = (index) => {
        if (listRef && listRef.current) {
            const { scrollToTop, srollToBottom } = listRef.current;
            scrollToTop(index);
        }
    };
    const listScrollToBottom = (index) => {
        if (listRef && listRef.current) {
            const { scrollToTop, srollToBottom } = listRef.current;
            srollToBottom(index);
        }
    };
    const handleItemSelect = (ids, param_activeIds, curId) => {
        if (beforeSelected) {
            const customActiveIds = beforeSelected(ids, param_activeIds, curId);
            _activeIds.current = customActiveIds;
            onSelect && onSelect(ids, customActiveIds, curId);
        }
        else {
            onSelect && onSelect(ids, param_activeIds, curId);
        }
    };
    const handleItenUnSelect = (ids, param_activeIds, curId) => {
        if (beforeSelected) {
            const customActiveIds = beforeSelected(ids, param_activeIds, curId);
            _activeIds.current = customActiveIds;
            onUnSelect && onUnSelect(ids, customActiveIds, curId);
        }
        else {
            onUnSelect && onUnSelect(ids, param_activeIds, curId);
        }
    };
    const handleItemonContextmenu = (key, mail, index, event) => {
        onContextMenu && onContextMenu(key, mail, index, event);
    };
    const handleItemActive = id => {
        const index = id2Index(id);
        const _data = data[index];
        onActive && onActive(id, index, _data, _activeIds.current);
    };
    const handleItemDelete = ids => {
        onDelete && onDelete(ids);
    };
    const modelOperMap = {
        [LIST_MODEL.INIT]: {
            handleChecked: (item, checked) => {
                const id = dataItem2keyMap.get(item);
                if (checked) {
                    clearActive();
                    addActiveId(id);
                    setShiftActiveId(id);
                    setShiftCurId(id);
                    handleItemSelect([id], _activeIds.current, id);
                    setListModel(LIST_MODEL.MULTIPLE);
                }
                else {
                }
            },
            handleClick: item => {
                const id = dataItem2keyMap.get(item);
                handleItemActive(id);
            },
            handleShiftClick: item => {
                const id = dataItem2keyMap.get(item);
                const curIndex = id2Index(id);
                const ids = [];
                if (data && data.length) {
                    for (let i = 0; i <= curIndex; i++) {
                        const dateItem = data[i];
                        const itemId = dataItem2keyMap.get(dateItem);
                        ids.push(itemId);
                    }
                }
                addActiveId(ids);
                handleItemSelect(ids, _activeIds.current, id);
                setShiftCurId(id);
                if (curIndex > 0) {
                    setListModel(LIST_MODEL.MULTIPLE);
                }
                else {
                    setListModel(LIST_MODEL.SINGLE);
                    handleItemActive(id);
                }
            },
            handleComClick: (item, index) => {
                const id = dataItem2keyMap.get(item);
                handleItemActive(id);
                addActiveId(id);
                setShiftActiveId(id);
                handleItemSelect([id], _activeIds.current, id);
                setListModel(LIST_MODEL.SINGLE);
            },
            handleKeyDown: () => {
                if (data && data.length) {
                    const id = dataItem2keyMap.get(data[0]);
                    setListModel(LIST_MODEL.SINGLE);
                    clearActive();
                    addActiveId(id);
                    setShiftActiveId(id);
                    handleItemSelect([id], _activeIds.current, id);
                    setShiftCurId(id);
                }
            },
            handleKeyShiftUp: () => {
            },
            handleKeyShiftDown: () => {
                const curIndex = 0;
                if (data && data.length) {
                    const id = dataItem2keyMap.get(data[curIndex]);
                    addActiveId(id);
                    handleItemActive(id);
                    handleItemSelect(id, _activeIds.current, id);
                    setShiftCurId(id);
                }
                setListModel(LIST_MODEL.SINGLE);
            },
            handleKeyCommandA: () => {
                if (data && data.length) {
                    const ids = data.map(item => dataItem2keyMap.get(item));
                    addActiveId(ids);
                    setShiftActiveId(ids[0]);
                    handleItemSelect(ids, _activeIds.current, []);
                    setShiftCurId(ids[ids.length - 1]);
                    setListModel(LIST_MODEL.MULTIPLE);
                }
            },
            handleKeyDelete: () => {
                if (_activeIds && _activeIds.current && _activeIds.current.length) {
                    const idList = _activeIds.current;
                    handleItemDelete && handleItemDelete([...idList]);
                }
            },
        },
        [LIST_MODEL.SINGLE]: {
            handleChecked: (item, checked) => {
                const id = dataItem2keyMap.get(item);
                if (checked) {
                    clearActive();
                    addActiveId(id);
                    setShiftActiveId(id);
                    setShiftCurId(id);
                    handleItemSelect([id], _activeIds.current, id);
                    setListModel(LIST_MODEL.MULTIPLE);
                }
                else {
                }
            },
            handleClick: mail => {
                const id = dataItem2keyMap.get(mail);
                handleItemActive(id);
            },
            handleShiftClick: mail => {
                const id = dataItem2keyMap.get(mail);
                const curIndex = id2Index(id);
                const startIndex = id2Index(shiftActiveId);
                const ids = [];
                const start = startIndex < curIndex ? startIndex : curIndex;
                const end = curIndex > startIndex ? curIndex : startIndex;
                if (data && data.length) {
                    for (let i = start; i <= end; i++) {
                        const mail = data[i];
                        ids.push(dataItem2keyMap.get(mail));
                    }
                }
                addActiveId(ids);
                handleItemSelect(ids, _activeIds.current, id);
                setShiftCurId(id);
                setListModel(LIST_MODEL.MULTIPLE);
            },
            handleComClick: mail => {
                const id = dataItem2keyMap.get(mail);
                if (idIsActive(id)) {
                    if (data.length > 1 && _activeIds.current.length > 1) {
                        deleteActiveId(id);
                        setShiftActiveId(id);
                        handleItenUnSelect([id], _activeIds.current, id);
                        setListModel(LIST_MODEL.MULTIPLE);
                    }
                }
                else {
                    addActiveId(id);
                    setShiftActiveId(id);
                    handleItemSelect([id], _activeIds.current, id);
                    setListModel(LIST_MODEL.MULTIPLE);
                }
                setShiftCurId(id);
            },
            handleKeyUp: () => {
                if (shiftActiveId) {
                    const index = id2Index(shiftActiveId);
                    if (index >= 1) {
                        const mail = data[index - 1];
                        const id = dataItem2keyMap.get(mail);
                        clearActive();
                        setListModel(LIST_MODEL.SINGLE);
                        setActiveIds([id]);
                        setShiftActiveId(id);
                        handleItemSelect([id], _activeIds.current, id);
                        setShiftCurId(id);
                        listScrollToTop(index - 1);
                    }
                }
            },
            handleKeyDown: () => {
                if (shiftActiveId) {
                    const index = id2Index(shiftActiveId);
                    if (index < data.length - 1) {
                        const mail = data[index + 1];
                        const id = dataItem2keyMap.get(mail);
                        if (mail && id) {
                            clearActive();
                            setListModel(LIST_MODEL.SINGLE);
                            setActiveIds([id]);
                            setShiftActiveId(id);
                            handleItemSelect([id], _activeIds.current, id);
                            setShiftCurId(id);
                            listScrollToBottom(index + 1);
                        }
                    }
                }
            },
            handleKeyShiftUp: () => {
                const index = id2Index(shiftActiveId);
                if (index != null && index - 1 > 0) {
                    const mailId = dataItem2keyMap.get(data[index - 1]);
                    addActiveId(mailId);
                    handleItemSelect(mailId, _activeIds.current, mailId);
                    setShiftCurId(mailId);
                    listScrollToTop(index - 1);
                    setListModel(LIST_MODEL.MULTIPLE);
                }
            },
            handleKeyShiftDown: () => {
                const index = id2Index(shiftActiveId);
                if (index != null && index + 1 < data.length - 1) {
                    const mailId = dataItem2keyMap.get(data[index + 1]);
                    addActiveId(mailId);
                    handleItemSelect(mailId, _activeIds.current, mailId);
                    setShiftCurId(mailId);
                    listScrollToBottom(index + 1);
                    setListModel(LIST_MODEL.MULTIPLE);
                }
            },
            handleKeyCommandA: () => {
                if (data && data.length) {
                    const ids = data.map(item => dataItem2keyMap.get(item));
                    addActiveId(ids);
                    setShiftActiveId(ids[0]);
                    handleItemSelect(ids, _activeIds.current, []);
                    setShiftCurId(ids[ids.length - 1]);
                    setListModel(LIST_MODEL.MULTIPLE);
                }
            },
            handleKeyDelete: () => {
                if (_activeIds && _activeIds.current && _activeIds.current.length) {
                    const idList = _activeIds.current;
                    handleItemDelete && handleItemDelete([...idList]);
                }
            },
        },
        [LIST_MODEL.MULTIPLE]: {
            handleChecked: (item, checked) => {
                const id = dataItem2keyMap.get(item);
                if (checked) {
                    addActiveId(id);
                    setShiftActiveId(id);
                    setShiftCurId(id);
                    handleItemSelect([id], _activeIds.current, id);
                    setListModel(LIST_MODEL.MULTIPLE);
                }
                else if (idIsActive(id)) {
                    if (_activeIds.current.length <= 1) {
                        addActiveId(id);
                        setShiftActiveId(id);
                        setShiftCurId(id);
                        handleItemUnSelected(id);
                        setListModel(LIST_MODEL.SINGLE);
                    }
                    else {
                        if (data.length > 1 && _activeIds.current.length > 1) {
                            deleteActiveId(id);
                            handleItenUnSelect([id], _activeIds.current, id);
                            const index = id2Index(id);
                            const top = index - 1 >= 0 ? index - 1 : 0;
                            const bottom = index + 1 <= data.length - 1 ? index + 1 : data.length - 1;
                            if (!idIsActive(id2Index(top)) && !idIsActive(id2Index(bottom))) {
                                if (_activeIds.current.length == 0) {
                                    setShiftActiveId(dataItem2keyMap.get(data[0]));
                                    setShiftCurId(dataItem2keyMap.get(data[0]));
                                    return;
                                }
                                for (let i = index; i < data.length; i++) {
                                    const _id = dataItem2keyMap.get(data[i]);
                                    if (idIsActive(_id)) {
                                        setShiftActiveId(_id);
                                        for (let n = i; n < data.length; n++) {
                                            const _id = dataItem2keyMap.get(data[n]);
                                            if (!idIsActive(_id)) {
                                                if (n - 1 >= 0) {
                                                    setShiftCurId(dataItem2keyMap.get(data[n - 1]));
                                                }
                                                return;
                                            }
                                        }
                                        return;
                                    }
                                }
                                for (let i = index; i >= 0; i--) {
                                    const _id = dataItem2keyMap.get(data[i]);
                                    if (idIsActive(_id)) {
                                        setShiftActiveId(_id);
                                        for (let n = i; n >= 0; n--) {
                                            const _id = dataItem2keyMap.get(data[n]);
                                            if (!idIsActive(_id)) {
                                                if (n + 1 < data.length) {
                                                    setShiftCurId(dataItem2keyMap.get(data[n + 1]));
                                                }
                                                return;
                                            }
                                        }
                                        return;
                                    }
                                }
                            }
                            setListModel(LIST_MODEL.MULTIPLE);
                        }
                    }
                }
            },
            handleClick: mail => {
                const id = dataItem2keyMap.get(mail);
                handleItemActive(id);
            },
            handleShiftClick: mail => {
                let curIndex = id2Index(shiftCurId);
                const startIndex = id2Index(shiftActiveId);
                let direction = curIndex >= startIndex;
                let start = direction ? startIndex : curIndex;
                let end = direction ? curIndex : startIndex;
                const activeIdList = [];
                let _shiftCurId = dataItem2keyMap.get(mail);
                const unActiveList = [];
                if (shiftCurId) {
                    for (let i = start; i <= end; i++) {
                        const mail = data[i];
                        unActiveList.push(dataItem2keyMap.get(mail));
                    }
                }
                curIndex = id2Index(dataItem2keyMap.get(mail));
                direction = curIndex >= startIndex;
                start = startIndex < curIndex ? startIndex : curIndex;
                end = curIndex > startIndex ? curIndex : startIndex;
                if (data && data.length) {
                    for (let i = start; i <= end; i++) {
                        const mail = data[i];
                        activeIdList.push(dataItem2keyMap.get(mail));
                    }
                }
                if (direction) {
                    if (curIndex + 1 < data.length && idIsActive(dataItem2keyMap.get(data[curIndex + 1]))) {
                        for (let i = curIndex + 1; i < data.length; i++) {
                            const id = dataItem2keyMap.get(data[i]);
                            if (idIsActive(id)) {
                                _shiftCurId = id;
                                continue;
                            }
                            break;
                        }
                    }
                }
                else if (curIndex - 1 < data.length && idIsActive(dataItem2keyMap.get(data[curIndex - 1]))) {
                    for (let i = curIndex - 1; i >= 0; i--) {
                        const id = dataItem2keyMap.get(data[i]);
                        if (idIsActive(id)) {
                            _shiftCurId = id;
                            continue;
                        }
                        break;
                    }
                }
                if (idIsActive(dataItem2keyMap.get(mail))) {
                    if (direction) {
                        if (curIndex + 1 < data.length && idIsActive(dataItem2keyMap.get(data[curIndex + 1]))) {
                            for (let i = curIndex + 1; i < data.length; i++) {
                                const id = dataItem2keyMap.get(data[i]);
                                if (idIsActive(id)) {
                                    unActiveList.push(id);
                                    continue;
                                }
                                break;
                            }
                        }
                    }
                    else if (curIndex - 1 >= 0 && idIsActive(dataItem2keyMap.get(data[curIndex - 1]))) {
                        for (let i = curIndex - 1; i >= 0; i--) {
                            const id = dataItem2keyMap.get(data[i]);
                            if (idIsActive(id)) {
                                unActiveList.push(id);
                                continue;
                            }
                            break;
                        }
                    }
                }
                deleteActiveId(unActiveList);
                addActiveId(activeIdList);
                handleItemSelect(activeIdList, _activeIds.current, _shiftCurId);
                setShiftCurId(_shiftCurId);
                setListModel(LIST_MODEL.MULTIPLE);
            },
            handleComClick: mail => {
                const id = dataItem2keyMap.get(mail);
                if (idIsActive(id)) {
                    if (data.length > 1 && _activeIds.current.length > 1) {
                        deleteActiveId(id);
                        handleItenUnSelect([id], _activeIds.current, id);
                        const index = id2Index(id);
                        const top = index - 1 >= 0 ? index - 1 : 0;
                        const bottom = index + 1 <= data.length - 1 ? index + 1 : data.length - 1;
                        if (!idIsActive(id2Index(top)) && !idIsActive(id2Index(bottom))) {
                            if (_activeIds.current.length == 0) {
                                setShiftActiveId(dataItem2keyMap.get(data[0]));
                                setShiftCurId(dataItem2keyMap.get(data[0]));
                                return;
                            }
                            for (let i = index; i < data.length; i++) {
                                const _id = dataItem2keyMap.get(data[i]);
                                if (idIsActive(_id)) {
                                    setShiftActiveId(_id);
                                    for (let n = i; n < data.length; n++) {
                                        const _id = dataItem2keyMap.get(data[n]);
                                        if (!idIsActive(_id)) {
                                            if (n - 1 >= 0) {
                                                setShiftCurId(dataItem2keyMap.get(data[n - 1]));
                                            }
                                            return;
                                        }
                                    }
                                    return;
                                }
                            }
                            for (let i = index; i >= 0; i--) {
                                const _id = dataItem2keyMap.get(data[i]);
                                if (idIsActive(_id)) {
                                    setShiftActiveId(_id);
                                    for (let n = i; n >= 0; n--) {
                                        const _id = dataItem2keyMap.get(data[n]);
                                        if (!idIsActive(_id)) {
                                            if (n + 1 < data.length) {
                                                setShiftCurId(dataItem2keyMap.get(data[n + 1]));
                                            }
                                            return;
                                        }
                                    }
                                    return;
                                }
                            }
                        }
                        setListModel(LIST_MODEL.MULTIPLE);
                    }
                }
                else {
                    addActiveId(id);
                    setShiftActiveId(id);
                    setShiftCurId(id);
                    handleItemSelect([id], _activeIds.current, id);
                    setListModel(LIST_MODEL.MULTIPLE);
                }
            },
            handleKeyUp: () => {
                if (shiftActiveId) {
                    const index = id2Index(shiftActiveId);
                    if (index > 1) {
                        const mail = data[index - 1];
                        const id = dataItem2keyMap.get(mail);
                        clearActive();
                        setListModel(LIST_MODEL.SINGLE);
                        setActiveIds([id]);
                        setShiftActiveId(id);
                        handleItemSelect([id], _activeIds.current, id);
                        setShiftCurId(id);
                        listScrollToTop(index - 1);
                    }
                }
            },
            handleKeyDown: () => {
                if (shiftActiveId) {
                    const index = id2Index(shiftActiveId);
                    if (index < data.length - 1) {
                        const mail = data[index + 1];
                        const id = dataItem2keyMap.get(mail);
                        if (mail && id) {
                            clearActive();
                            setListModel(LIST_MODEL.SINGLE);
                            setActiveIds([id]);
                            setShiftActiveId(id);
                            handleItemSelect([id], _activeIds.current, id);
                            setShiftCurId(id);
                            listScrollToBottom(index + 1);
                        }
                    }
                }
            },
            handleKeyShiftUp: () => {
                const index = shiftCurId ? id2Index(shiftCurId) : id2Index(shiftActiveId);
                const direction = index > id2Index(shiftActiveId);
                listScrollToTop(index - 1);
                if (direction) {
                    if (index != null && index >= 0) {
                        const mailId = dataItem2keyMap.get(data[index]);
                        deleteActiveId(mailId);
                        handleItenUnSelect([mailId], _activeIds.current, mailId);
                        if (index - 1 >= 0) {
                            setShiftCurId(dataItem2keyMap.get(data[index - 1]));
                        }
                        else {
                            setShiftCurId(mailId);
                        }
                    }
                }
                else if (index != null && index - 1 >= 0) {
                    let mailId = dataItem2keyMap.get(data[index - 1]);
                    if (idIsActive(mailId) && index - 2 >= 0) {
                        for (let i = index - 2; i >= 0; i--) {
                            const _mailId = dataItem2keyMap.get(data[i]);
                            if (!idIsActive(_mailId)) {
                                mailId = _mailId;
                                break;
                            }
                        }
                    }
                    addActiveId(mailId);
                    handleItemSelect(mailId, _activeIds.current, mailId);
                    setShiftCurId(mailId);
                }
                setListModel(LIST_MODEL.MULTIPLE);
            },
            handleKeyShiftDown: () => {
                const index = id2Index(shiftCurId);
                const direction = index >= id2Index(shiftActiveId);
                listScrollToBottom(index + 1);
                if (direction) {
                    if (index != null && index + 1 < data.length) {
                        const mailId = dataItem2keyMap.get(data[index + 1]);
                        let nextMailId = null;
                        for (let i = index + 2; i < data.length; i++) {
                            const _mailId = dataItem2keyMap.get(data[i]);
                            if (_mailId && idIsActive(_mailId)) {
                                nextMailId = _mailId;
                                continue;
                            }
                            break;
                        }
                        addActiveId(mailId);
                        handleItemSelect(mailId, _activeIds.current, mailId);
                        setShiftCurId(nextMailId || mailId);
                    }
                }
                else if (index != null && index <= data.length - 1) {
                    const mailId = dataItem2keyMap.get(data[index]);
                    deleteActiveId(mailId);
                    handleItenUnSelect([mailId], _activeIds.current, mailId);
                    if (index + 1 <= data.length - 1) {
                        setShiftCurId(dataItem2keyMap.get(data[index + 1]));
                    }
                    else {
                        setShiftCurId(mailId);
                    }
                }
                setListModel(LIST_MODEL.MULTIPLE);
            },
            handleKeyCommandA: () => {
                if (data && data.length) {
                    const ids = data.map(item => dataItem2keyMap.get(item));
                    addActiveId(ids);
                    setShiftActiveId(ids[0]);
                    handleItemSelect(ids, _activeIds.current, []);
                    setShiftCurId(ids[ids.length - 1]);
                    setListModel(LIST_MODEL.MULTIPLE);
                }
            },
            handleKeyDelete: () => {
                if (_activeIds && _activeIds.current && _activeIds.current.length) {
                    const idList = _activeIds.current;
                    handleItemDelete && handleItemDelete([...idList]);
                }
            },
        },
    };
    const handleItemSelected = (key, dataItem, index, event) => {
        const { altKey, metaKey, ctrlKey, shiftKey } = event || {};
        const logicCtrlKey = metaKey || ctrlKey || altKey;
        if (Array.isArray(key) && key.length > 0) {
            if (key.length == 1) {
                modelLockRef.current = true;
                setTimeout(() => {
                    setListModel(LIST_MODEL.MULTIPLE);
                }, 0);
                setTimeout(() => {
                    modelLockRef.current = false;
                }, 1000);
            }
            onSelect && onSelect(key, [...new Set([...(_activeIds.current || []), ...key])], null);
        }
        else {
            if (logicCtrlKey) {
                handleComClick(event, index);
            }
            else if (shiftKey) {
                handleShiftClick(event, index);
            }
            else {
                handleClick(event, index);
            }
        }
    };
    const handleItemUnSelected = (key, dataItem, index, event) => {
        modelLockRef.current = false;
        if (Array.isArray(key) && key.length > 0) {
            onUnSelect &&
                onUnSelect(key, (_activeIds.current || []).filter(item => !key.includes(item)), null);
        }
        else {
            onUnSelect &&
                onUnSelect([key], (_activeIds.current || []).filter(item => item !== key), null);
        }
    };
    const handleItemChecked = (checked, key, dataItem, index, event) => {
        const mail = data[index];
        const fn = modelOperMap[refListModel.current].handleChecked;
        fn && fn(mail, checked, index);
    };
    const onItemContentMenuProxy = (key, mail, index, event) => {
        if (mail) {
            const id = dataItem2keyMap.get(mail);
            if (idIsActive(id)) {
                const mailList = _activeIds.current.map(id => data[id2Index(id)]);
                handleItemonContextmenu(key, mailList, index, event);
                return;
            }
            else {
                handleItemonContextmenu(key, mail, index, event);
            }
        }
    };
    const handleClick = (e, index) => {
        const mail = data[index];
        const fn = modelOperMap[refListModel.current].handleClick;
        fn && fn(mail, index);
    };
    const handleComClick = (e, index) => {
        if (hkDisabled) {
            return false;
        }
        const mail = data[index];
        const fn = modelOperMap[refListModel.current].handleComClick;
        fn && fn(mail, index);
    };
    const handleShiftClick = (e, index) => {
        if (hkDisabled) {
            return false;
        }
        const mail = data[index];
        const fn = modelOperMap[refListModel.current].handleShiftClick;
        fn && fn(mail, index);
    };
    const handleKeyUp = e => {
        if (hkDisabled) {
            return false;
        }
        e.preventDefault();
        const fn = modelOperMap[refListModel.current].handleKeyUp;
        fn && fn();
    };
    const handleKeyDown = e => {
        if (hkDisabled) {
            return false;
        }
        e.preventDefault();
        const fn = modelOperMap[refListModel.current].handleKeyDown;
        fn && fn();
    };
    const handleKeyShiftUp = e => {
        if (hkDisabled) {
            return false;
        }
        e.preventDefault();
        const fn = modelOperMap[refListModel.current].handleKeyShiftUp;
        fn && fn();
    };
    const handleKeyShiftDown = e => {
        if (hkDisabled) {
            return false;
        }
        e.preventDefault();
        const fn = modelOperMap[refListModel.current].handleKeyShiftDown;
        fn && fn();
    };
    const handleKeyCommandA = e => {
        if (hkDisabled) {
            return false;
        }
        e.preventDefault();
        const fn = modelOperMap[refListModel.current].handleKeyCommandA;
        !e.repeat && fn && fn();
    };
    const handleKeyDelete = e => {
        if (hkDisabled) {
            return false;
        }
        e.preventDefault();
        const fn = modelOperMap[refListModel.current].handleKeyDelete;
        !e.repeat && fn && fn();
    };
    const handleKeyEnter = e => {
        if (hkDisabled) {
            return false;
        }
        e.preventDefault();
        if (!e.repeat && onActive) {
            if (activeId && activeId.length == 1) {
                handleItemActive(activeId[0]);
            }
        }
    };
    const throttleHandleKeyUp = useCreateCallbackForEvent(handleKeyUp);
    const throttleHandleKeyDown = useCreateCallbackForEvent(handleKeyDown);
    const throttleHandleKeyShiftUp = useCreateCallbackForEvent(handleKeyShiftUp);
    const throttleHandleKeyShiftDown = useCreateCallbackForEvent(handleKeyShiftDown);
    const refHandleKeyCommandA = useCreateCallbackForEvent(handleKeyCommandA);
    const throttleHandleKeyDelete = useThrottleForEvent(handleKeyDelete, 800);
    const throttleHandleEnter = useCreateCallbackForEvent(handleKeyEnter);
    const listHotKeyHandler = {
        [ListHotKey.KEY_UP]: throttleHandleKeyUp,
        [ListHotKey.KEY_DOWN]: throttleHandleKeyDown,
        [ListHotKey.SHIFT_KEY_UP]: throttleHandleKeyShiftUp,
        [ListHotKey.SHIFT_KEY_DOWN]: throttleHandleKeyShiftDown,
        [ListHotKey.COMMAND_A]: refHandleKeyCommandA,
        [ListHotKey.ENTER]: throttleHandleEnter,
    };
    useEffect(() => {
        if (data && data.length && ((activeId && activeId.length === 0) || !shiftCurId || !shiftActiveId)) {
            const id = getUniqKey(0, data[0]);
            setShiftActiveId(id);
            setShiftCurId(id);
        }
    }, [data]);
    useEffect(() => {
        mailId2ListIndexMap.clear();
        dataItem2keyMap.clear();
        data.forEach((item, index) => {
            const id = getUniqKey(index, item);
            mailId2ListIndexMap.set(id, index);
            dataItem2keyMap.set(item, id);
        });
        setId2IndexMap(mailId2ListIndexMap);
        setDateItem2keyMap(dataItem2keyMap);
    }, [data]);
    useImperativeHandle(ref, () => {
        return listRef.current;
    }, [listRef]);
    const HotKeyEventOrigin = CustomEventOrign || HotKeys;
    return (React.createElement(HotKeyEventOrigin, { keyMap: keyMap, handlers: listHotKeyHandler, hkDisabled: hkDisabled },
        React.createElement(ListCom, Object.assign({ ref: listRef }, props, { onSelect: handleItemSelected, onUnSelect: handleItemUnSelected, onContextMenu: onItemContentMenuProxy, onChecked: handleItemChecked, selectIsCapture: true }))));
});
export default HotKey;
